import { z } from "zod"

import {
  branchIdSchema,
  entityIdSchema,
  legalEntityIdSchema,
} from "./identifiers.js"

const moneySchema = z.string().regex(/^(0|[1-9]\d{0,15})\.\d{2}$/)

export const payrollAccountingSummaryPostV1Schema = z.object({
  summaryId: entityIdSchema,
  postingId: entityIdSchema,
  runId: entityIdSchema,
  configurationId: entityIdSchema,
  configurationVersion: z.number().int().positive(),
  postingDate: z.iso.date(),
}).strict()

export const payrollAccountingSummaryResultV1Schema = z.object({
  entityType: z.literal("payroll_accounting_summary"),
  entityId: entityIdSchema,
  state: z.literal("posted"),
  version: z.literal(1),
  runId: entityIdSchema,
  legalEntityId: legalEntityIdSchema,
  branchId: branchIdSchema,
  currency: z.literal("USD"),
  totalAmount: moneySchema,
  totalEarnings: moneySchema,
  employeeTaxTotal: moneySchema,
  employerTaxTotal: moneySchema,
  deductionTotal: moneySchema,
  checkTotal: moneySchema,
  financialPostingId: entityIdSchema,
  erpnextDocumentType: z.literal("Journal Entry"),
  erpnextDocumentId: z.string().trim().min(1).max(140),
  authoritativeSource: z.literal("Worklio"),
  recalculated: z.literal(false),
  balanced: z.literal(true),
  postedExactlyOnce: z.literal(true),
  periodTreatment: z.enum(["current_period", "late_adjustment"]),
  originalEventAt: z.string().datetime({ offset: true }),
  originalPostingDate: z.iso.date(),
  adjustmentPostingDate: z.iso.date(),
  closedPeriodId: entityIdSchema.nullable(),
  periodReopened: z.literal(false),
}).strict()

export type PayrollAccountingSummaryPostV1 = z.infer<
  typeof payrollAccountingSummaryPostV1Schema
>
export type PayrollAccountingSummaryResultV1 = z.infer<
  typeof payrollAccountingSummaryResultV1Schema
>
